var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('font-awesome-icon',{staticClass:"header_icon",attrs:{"icon":_vm.icon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }